module.exports = __webpack_public_path__ + "static/media/at.0bb707d4.svg";